import React, { useState, useEffect } from "react";
import {
  Navbar,
  TeamClientForm,
  Button,
  WeeklyGoals,
  ProductivityGraph,
  EventCalendar,
} from "../../components/indexComponents";
import "../../CSS/TeamDashboard.css";
import { useParams } from "react-router-dom";

function TeamDashboard() {
  const { teamId } = useParams();
  const [team, setTeam] = useState([]);
  const [formClient, setFormClient] = useState(false);
  const [isMember, setIsMember] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [stepDone, setStepDone] = useState([]);
  const [memberStepDone, setMemberStepDone] = useState([]);

  const getPastWeekDates = () => {
    let dates = "0123456".split("").map((day) => {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() - day);
      return tempDate.toLocaleDateString("en-US");
    });
    return dates.reverse();
  };

  const getTeamInfo = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/team/${teamId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 403) {
        setIsMember(false);
        setIsLoading(false);
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch team informations");
      }

      const data = await response.json();
      console.log(data);
      setTeam(data);
      setIsLoading(false);

      const result = [];

      data.Team_Members.forEach((member) => {
        const { username } = member;

        const last7Days = getPastWeekDates().map((date) => ({
          date,
          nbre_steps_done: 0,
        }));
        console.log(last7Days);

        if (member.steps_done) {
          /* for (const step of member.steps_done) {
            const index = last7Days.findIndex((day) => day.date === step.date);

            if (index !== -1) {
              last7Days[index].nbre_steps_done = step.nbre_steps_done;
            }
          } */
          // Remplir le tableau avec les valeurs des étapes effectuées
          for (const step of member.steps_done) {
            const stepDate = new Date(step.date).toLocaleDateString("en-US");
            const index = last7Days.findIndex((day) => day.date === stepDate);
            console.log("index :", index);
            if (index !== -1) {
              last7Days[index + 1].nbre_steps_done = step.nbre_steps_done;
            }
          }
        }

        const nbreStepsDone = last7Days.map((day) => day.nbre_steps_done);

        const memberData = {
          username,
          nbreStepsDone,
        };

        result.push(memberData);
      });
      console.log("resultat : ", result);
      setMemberStepDone(result);
    } catch (error) {
      console.error("Error getting team information:", error);
    }
  };

  const getStepDone = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/step-done`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }

      const data = await response.json();
      setStepDone(data);
    } catch (error) {
      console.error("Error updating step done:", error);
    }
  };

  useEffect(() => {
    getTeamInfo();
    getStepDone();
  }, []);

  return (
    <main className="TeamDashboard-frame page-frame">
      <Navbar onClickTeam={getTeamInfo} />
      <div className="TeamDashboard-content page-content">
        {!isLoading ? (
          <>
            {isMember ? (
              <>
                <div className="dashboard-header">
                  <h1>
                    Bienvenue sur le tableau de bord de l'équipe {team.name}
                  </h1>
                </div>

                <div className="btn-container">
                  <Button
                    route={`/team-tasks/${teamId}`}
                    text="Tâche de l'équipe"
                  />
                  <Button
                    route={`/team-clients/${teamId}`}
                    text="Liste des clients"
                  />
                </div>

                {formClient ? (
                  <TeamClientForm
                    onClientAdded={() => {
                      getTeamInfo();
                      setFormClient(false);
                    }}
                    close={() => setFormClient(false)}
                    teamId={teamId}
                  />
                ) : (
                  <div></div>
                )}

                <EventCalendar isTeam={"true"} teamId={teamId} />

                <div className="list-container">
                  <WeeklyGoals
                    weeklyTasks={team.weekly_objectives}
                    idTeam={teamId}
                  />
                </div>

                <div className="w-100 flex jc-center align-center col">
                  <h2 className="h2">Productivité (7 derniers jours)</h2>
                  <div className="graph-container">
                    {memberStepDone ? (
                      <ProductivityGraph
                        membersStepDone={memberStepDone}
                        isTeam={true}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="not-member">
                  <h1>Vous n'êtes pas membre de cette équipe</h1>
                </div>
              </>
            )}
          </>
        ) : (
          <div>
            <h1>Chargement de l'équipe...</h1>
          </div>
        )}
      </div>
    </main>
  );
}

export default TeamDashboard;
